import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RadioButtonComponent } from './radioButton.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: RadioButtonComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class RadioRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/radioButton/radio-routing.module.ts